
















import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import { defineComponent } from '@vue/composition-api';
import DeclineGroupInvitation from '../DeclineGroupInvitation.vue';

export default defineComponent({
	components: { ColumnContainer, DeclineGroupInvitation },
	props: {
		alertView: Boolean,
		canDeclineInvitation: Boolean,
		groupId: {
			type: String,
			default: '',
		},
	},
});
